import { _ } from "vue-underscore";
import Vue from "vue";
import api from "../utils/api.js";
import { OUTFIT_TYPES } from "../../config.js";

export const featuredCollections = {
    namespaced: true,
    state: {
        featuredCollectionOutfits: [],
    },
    getters: {
        featuredCollectionOutfits(state) {
            return state.featuredCollectionOutfits;
        },
    },
    mutations: {
        setFeaturedCollectionOutfits(state, outfits) {
            state.featuredCollectionOutfits = outfits.map((outfit) => ({
                ...outfit,
                currentProductIndex: 0,
                type: OUTFIT_TYPES.FEATURED,
            }));
        },
        changeOutfitProduct(state, payload) {
            const { index: productIndex, product, outfitId } = payload;
            const outfitIndex = state.featuredCollectionOutfits.findIndex((outfit) => outfit.outfit_id === outfitId);
            const { products } = state.featuredCollectionOutfits[outfitIndex];

            products.splice(productIndex, 1, product);

            Vue.set(state.featuredCollectionOutfits[outfitIndex], "products", products);
        },
        changeCurrentProduct(state, payload) {
            const { currentProductIndex, outfitId } = payload;
            let { outfitIndex } = payload;

            if (outfitIndex == undefined)
                outfitIndex = state.featuredCollectionOutfits.findIndex((outfit) => outfit.outfit_id === outfitId);
            const outfitFromState = state.featuredCollectionOutfits[outfitIndex];

            state.featuredCollectionOutfits.splice(outfitIndex, 1, {
                ...outfitFromState,
                currentProductIndex,
            });
        },
    },
    actions: {
        fetchFeaturedCollectionOutfits(context, payload) {
            const uri = api.collectionsUri() + payload.collectionId + "/outfits";
            const page = payload.page;
            const limit = 10;

            let scrollToTop = false;

            return api
                .get(uri, {
                    params: {
                        limit,
                        page,
                    }
                })
                .then((response) => {
                    if(!_.isEqual(
                        context.state.featuredCollectionOutfits.slice(page*limit, page*limit + limit).map(outfit => outfit.outfit_id),
                        response.outfits.map(outfit => outfit.outfit_id))
                    ) {
                        context.commit("setFeaturedCollectionOutfits", 
                            [
                                ...context.state.featuredCollectionOutfits.slice(0, page*limit), 
                                ...response.outfits,
                            ]
                        );
                        if (payload.page === 0) {
                            scrollToTop = true;
                        }
                    }

                    return {
                        outfits: response.outfits,
                        scrollToTop,
                    };
                })
                .catch((err) => {
                    console.log({err});
                    throw err;
                });
        },
    },
};
